module.exports = __webpack_public_path__ + "img/b3.8cd4f0b4.png";